module.exports = __webpack_public_path__ + "img/Frame_ItemFrame01_Color_Red.2c45bded.png";